import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "status-tabs"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('状态')) + " "), _c('a-popover', {
    attrs: {
      "content": _vm.t('转运服务商退件默认自提，弃货请联系客服'),
      "placement": "topRight"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "question-circle"
    }
  })], 1), _vm._v(" " + _vm._s(_vm.t('common', '：')))], 1), _c('a-tabs', {
    attrs: {
      "data-permission": "service_providers_return_list_order_status",
      "id": "service_providers_return_list_order_status",
      "data-sign": "service_providers_return_list_status",
      "animated": false
    },
    on: {
      "change": _vm.handleOrderStatusChange
    },
    model: {
      value: _vm.searchData.order_return_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "order_return_status", $$v);
      },
      expression: "searchData.order_return_status"
    }
  }, _vm._l(_vm.showReturnOrderStatusEnum, function (item) {
    return _c('a-tab-pane', {
      key: item.value
    }, [_c('div', {
      attrs: {
        "slot": "tab"
      },
      slot: "tab"
    }, [_vm._v(" " + _vm._s("" + item.text) + " ")])]);
  }), 1)], 1), _c('my-enter-search', {
    staticClass: "mt-10",
    attrs: {
      "data-sign": "service_form"
    },
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "service_providers_return_list_code_type",
      "id": "service_providers_return_list_code_type"
    },
    model: {
      value: _vm.searchData.code_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_type", $$v);
      },
      expression: "searchData.code_type"
    }
  }, _vm._l(_vm.codeTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "data-permission": "service_providers_return_list_code_value",
      "id": "service_providers_return_list_code_value",
      "data-sign": "service_providers_return_list_dblclick",
      "placeholder": _vm.t('common', '双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  })], 1), _c('div', {
    staticClass: "form-item-inline",
    staticStyle: {
      "vertical-align": "bottom",
      "line-height": "32px"
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u6536\u4EF6\u4ED3\u5E93"),
      "show-tip": "",
      "placeholder": _vm.t('收件仓库'),
      "data-permission": "service_providers_return_list_warehouse_code",
      "id": "service_providers_return_list_warehouse_code",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.receipts_warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "receipts_warehouse_code", $$v);
      },
      expression: "searchData.receipts_warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(_vm._s(item.warehouse_code) + "[" + _vm._s(item.warehouse_name) + "]")]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u7269\u6D41\u4EA7\u54C1"),
      "allow-clear": false,
      "data-permission": "service_providers_return_list_product_code",
      "id": "service_providers_return_list_product_code",
      "placeholder": _vm.t('物流产品'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.product_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_code", $$v);
      },
      expression: "searchData.product_code"
    }
  }, _vm._l(_vm.logisticsList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.product_code
      }
    }, [_vm._v(_vm._s(item.product_code) + "[" + _vm._s(item.product_cnname) + "]")]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "service_providers_return_list_time_type",
      "id": "service_providers_return_list_time_type",
      "value": "1"
    },
    model: {
      value: _vm.searchData.time_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_type", $$v);
      },
      expression: "searchData.time_type"
    }
  }, _vm._l(_vm.dateTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "data-permission": "service_providers_return_list_time_value",
      "id": "service_providers_return_list_time_value",
      "format": "YYYY/MM/DD"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "service_providers_return_list_search",
      "data-permission": "service_providers_return_list_search",
      "id": "service_providers_return_list_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "service_providers_return_list_reset",
      "data-permission": "service_providers_return_list_reset",
      "id": "service_providers_return_list_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedIdList.length))]), _c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "service_providers_return_list_export_all",
      "id": "service_providers_return_list_export_all",
      "data-sign": "service_providers_return_list_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "service_providers_return_list_export",
      "id": "service_providers_return_list_export",
      "data-sign": "service_providers_return_list_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "fixed-header": "",
      "useMouseTool": "",
      "is-filter-box": "",
      "name": "transportReturnOrder",
      "data-sign": "service_providers_return_list_table",
      "row-selection": _vm.rowSelection,
      "data-source": _vm.dataList,
      "row-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [record.receipts_warehouse_code ? _c('div', [_vm._v(_vm._s(record.receipts_warehouse_code) + "[" + _vm._s(record.warehouse_name) + "]")]) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))])]);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(_vm.t('签收')) + _vm._s(_vm.tc("：")) + _vm._s(_vm._f("filterEmpty")(record.sign_time)))]), _c('div', [_vm._v(_vm._s(_vm.t('下架')) + _vm._s(_vm.tc("：")) + _vm._s(_vm._f("filterEmpty")(record.off_shelf_time)))])]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "name": "transportReturnOrder",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    attrs: {
      "maxNumber": 200
    },
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };